import { reactive } from 'vue'
import { SECRET_CALL_TEXTS } from './secretCallTexts'

/**
 * Окно сообщений секретного звонка. Живёт на уровне приложения: звонок идёт на
 * своих экранах, где окна мессенджера не показываются.
 */
interface NoticeState {
  open: boolean
  title: string
  text: string
  okText: string
  cancelText: string
}

const state = reactive<NoticeState>({ open: false, title: '', text: '', okText: '', cancelText: '' })
let resolver: ((ok: boolean) => void) | null = null

export function useSecretCallNotice(): NoticeState {
  return state
}

function open(text: string, okText: string, cancelText: string, title: string): Promise<boolean> {
  // Новое окно заменяет предыдущее; прежний ждущий получает «отмену».
  resolver?.(false)
  state.title = title
  state.text = text
  state.okText = okText
  state.cancelText = cancelText
  state.open = true

  return new Promise<boolean>((resolve) => {
    resolver = resolve
  })
}

/** Сообщение с одной кнопкой. */
export function showSecretCallNotice(text: string, title: string = SECRET_CALL_TEXTS.title): Promise<boolean> {
  return open(text, 'Понятно', '', title)
}

/** Вопрос с выбором; true — согласие. */
export function confirmSecretCall(
  text: string,
  okText: string,
  cancelText = 'Отмена',
  title: string = SECRET_CALL_TEXTS.title,
): Promise<boolean> {
  return open(text, okText, cancelText, title)
}

export function closeSecretCallNotice(ok: boolean): void {
  state.open = false
  const r = resolver
  resolver = null
  r?.(ok)
}
